import { render, staticRenderFns } from "./rectifyTarget.vue?vue&type=template&id=8e1ada0c&scoped=true"
import script from "./rectifyTarget.vue?vue&type=script&lang=js"
export * from "./rectifyTarget.vue?vue&type=script&lang=js"
import style0 from "./rectifyTarget.vue?vue&type=style&index=0&id=8e1ada0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e1ada0c",
  null
  
)

export default component.exports